export function normalizeBaseUrl(value: string | undefined, fallback: string): string {
  const normalizedFallback = fallback.replace(/\/api$/, '').replace(/\/$/, '')
  const normalizedValue = (value ?? fallback).replace(/\/api$/, '').replace(/\/$/, '')

  // Some live builds pass VITE_API_BASE_URL=/api. For this project that would
  // incorrectly resolve requests to same-origin /api/... instead of /backend/api/...
  if (value === '/api' || normalizedValue === '') {
    return normalizedFallback
  }

  return normalizedValue
}

// Live-safe default:
// - same-origin backend under /backend (e.g. https://linqforce.de/backend/api/...)
// - local dev should override via VITE_API_BASE_URL in .env.local (e.g. http://localhost:8765)
export const API_BASE_URL = normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL as string | undefined, '/backend')
export const SITE_URL = normalizeBaseUrl(import.meta.env.VITE_SITE_URL as string | undefined, 'https://linqforce.de')

export function resolveBackendAssetUrl(url?: string | null): string {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url

  const normalizedPath = url.startsWith('/') ? url : `/${url}`
  const base = API_BASE_URL

  // If API base is absolute (e.g. localhost backend), assets are usually served there directly.
  if (/^https?:\/\//i.test(base)) {
    return `${base}${normalizedPath}`
  }

  // For relative API bases behind nginx (e.g. /api), media often lives under /backend/uploads.
  const relativeBase = base || ''
  const baseWithBackend = relativeBase.includes('/backend') ? relativeBase : `${relativeBase}/backend`
  return `${baseWithBackend}${normalizedPath}`.replace(/([^:]\/)\/+/g, '$1')
}
